import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { InvoiceCompaniesApi } from '../api/invoice-companies.api';
import { InvoiceCompany } from '../models/invoice-company.model';

@Injectable({ providedIn: 'root' })
export class InvoiceCompaniesService {
  private readonly _api = inject(InvoiceCompaniesApi);

  public get(): Observable<InvoiceCompany[]> {
    return this._api.get();
  }
}
